export const handleShareSite = async (url: string, handleSetSnackMessage: ({ message }: { message: string }) => void) => {
    if (typeof navigator.share !== 'undefined') {
        await navigator
            .share({
                title: 'WHyWHy',
                url
            })
            .then(() => {
                handleSetSnackMessage({ message: '分享成功！' });
            })
            .catch(async error => {
                await navigator.clipboard.writeText(url);
                console.error(error);
            });
    } else {
        await navigator.clipboard.writeText(url);
        handleSetSnackMessage({ message: '已複製分享連結！' });
    }

    return null;
};
